import { handleActions } from 'redux-actions';

import {
  clearWATemplatesOpts,
  resetCurrentWATemplate,
  resetCurrentWATemplateWithVariables,
  setCurrentWATemplate,
  setCurrentWATemplateWithVariables,
  setWATemplates,
  setWATemplatesOrder,
  setWATemplatesPage,
  setWATemplatesSearch,
  setWATemplatesSort,
} from '../actions/waTemplates';

const initialState = {
  templates: [],
  currentTemplate: null,
  currentTemplateWithVariables: null,
  total: 0,
  templatesPerPage: 10,
  page: 0,
  sort: 'name',
  order: 'asc',
  search: '',
};

export const waTemplates = handleActions(
  {
    [setWATemplates]: (
      state,
      { payload: { templates, total, templatesPerPage, page } = {} }
    ) => ({
      ...state,
      templates,
      total,
      page,
      templatesPerPage,
    }),
    [setCurrentWATemplate]: (state, { payload: currentTemplate }) => ({
      ...state,
      currentTemplate,
    }),
    [resetCurrentWATemplate]: (state) => ({
      ...state,
      currentTemplate: null,
    }),
    [setWATemplatesPage]: (state, { payload: page }) => ({
      ...state,
      page,
    }),
    [setWATemplatesSort]: (state, { payload: sort }) => ({
      ...state,
      sort,
    }),
    [setWATemplatesOrder]: (state, { payload: order }) => ({
      ...state,
      order,
    }),
    [setWATemplatesSearch]: (state, { payload: search }) => ({
      ...state,
      search,
      page: initialState.page,
    }),
    [clearWATemplatesOpts]: (state) => ({
      ...state,
      page: initialState.page,
      sort: initialState.sort,
      order: initialState.order,
      search: initialState.search,
    }),
    [setCurrentWATemplateWithVariables]: (
      state,
      { payload: currentTemplateWithVariables }
    ) => ({
      ...state,
      currentTemplateWithVariables,
    }),
    [resetCurrentWATemplateWithVariables]: (state) => ({
      ...state,
      currentTemplateWithVariables: null,
    }),
  },
  initialState
);
